import { Box, Typography } from '@mui/material';
import { themeColors } from 'toolkit/styles/colors';

interface SpeechBubbleProps {
  name: string;
  time: string;
  text: string;
  anchor: 'left' | 'right';
}

const SpeechBubble = ({ name, time, text, anchor }: SpeechBubbleProps) => {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        gap: '8px',
        borderRadius: '8px',
        padding: '16px',
        minWidth: '30%',
        maxWidth: '60%',
        backgroundColor:
          anchor === 'left'
            ? themeColors.surfaceSecondary
            : themeColors.inverseOnSurface,
        alignSelf: anchor === 'left' ? 'start' : 'end',
      }}
    >
      <Typography variant="titleSmall">{`${name} · ${time}`}</Typography>
      <Typography component="div" variant="bodyLarge">
        {text}
      </Typography>
    </Box>
  );
};

export default SpeechBubble;
